"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const getImageSource_1 = __importDefault(require("../definables/getImageSource"));
const state_1 = __importDefault(require("../../state"));
const gameWidth_1 = __importDefault(require("../../constants/gameWidth"));
const gameHeight_1 = __importDefault(require("../../constants/gameHeight"));
const ZIndexType_1 = __importDefault(require("../../enums/ZIndexType"));
const drawImage = (imageSourceSlug, opacity, sourceX, sourceY, sourceWidth, sourceHeight, x, y, width, height, zIndex) => {
    const imageSource = (0, getImageSource_1.default)(imageSourceSlug);
    if (x + width > 0 && x < gameWidth_1.default && y + height > 0 && y < gameHeight_1.default) {
        const texture = imageSource.getBaseTexture();
        const chopX = Math.max(x * -1, 0);
        const chopY = Math.max(y * -1, 0);
        const adjustedX = Math.max(x, 0);
        const adjustedY = Math.max(y, 0);
        const adjustedWidth = Math.min(width - chopX, gameWidth_1.default - adjustedX);
        const adjustedHeight = Math.min(height - chopY, gameHeight_1.default - adjustedY);
        const adjustedSourceX = chopX + sourceX;
        const adjustedSourceY = chopY + sourceY;
        const adjustedSourceWidth = Math.min(sourceWidth - chopX, adjustedWidth);
        const adjustedSourceHeight = Math.min(sourceHeight - chopY, adjustedHeight);
        const sprite = new pixi_js_1.Sprite(new pixi_js_1.Texture(texture, new pixi_js_1.Rectangle(adjustedSourceX, adjustedSourceY, adjustedSourceWidth, adjustedSourceHeight)));
        sprite.x = adjustedX;
        sprite.y = adjustedY;
        sprite.width = adjustedWidth;
        sprite.height = adjustedHeight;
        sprite.alpha = opacity;
        if (zIndex !== null) {
            switch (zIndex.type) {
                case ZIndexType_1.default.Hard: {
                    const hardZIndex = zIndex;
                    sprite.zIndex = hardZIndex.value;
                    break;
                }
                case ZIndexType_1.default.YSort: {
                    const ySortZindex = zIndex;
                    const ySortEntries = state_1.default.ySortEntries;
                    ySortEntries.push({
                        id: ySortZindex.ySortID,
                        sprite
                    });
                    state_1.default.ySortEntries = ySortEntries;
                    break;
                }
            }
        }
        state_1.default.app.stage.addChild(sprite);
    }
};
exports.default = drawImage;
